export const BATCHED_NOTIFICATION_WINDOWS = [
  { value: 5, label: "5 minutes" },
  { value: 15, label: "15 minutes" },
  { value: 30, label: "30 minutes" },
  { value: 60, label: "1 hour" },
  { value: 120, label: "2 hours" },
] as const

export type BatchedNotificationWindow = (typeof BATCHED_NOTIFICATION_WINDOWS)[number]["value"]

function formatDailyDigestHourLabel(hour: number) {
  const period = hour < 12 ? "AM" : "PM"
  const hour12 = hour % 12 === 0 ? 12 : hour % 12
  return `${hour12}:00 ${period}`
}

export const DAILY_DIGEST_HOURS = Array.from({ length: 24 }, (_, hour) => ({
  value: hour,
  label: formatDailyDigestHourLabel(hour),
}))

export type DailyDigestHour = (typeof DAILY_DIGEST_HOURS)[number]["value"]

export const MEETING_PREP_LEAD_DAYS = [
  { value: 1, label: "1 day before" },
  { value: 2, label: "2 days before" },
  { value: 3, label: "3 days before" },
  { value: 4, label: "4 days before" },
  { value: 5, label: "5 days before" },
  { value: 6, label: "6 days before" },
  { value: 7, label: "7 days before" },
] as const

export type MeetingPrepLeadDays = (typeof MEETING_PREP_LEAD_DAYS)[number]["value"]

export interface EmailNotificationOption {
  enabled: boolean
  label: string
  description: string
}

export interface NotificationSetting {
  guid: string
  batched_notification_window: BatchedNotificationWindow
  daily_digest_enabled: boolean
  daily_digest_hour: DailyDigestHour
  timezone: string | null
  meeting_prep_enabled: boolean
  meeting_prep_lead_days: MeetingPrepLeadDays
  email_notifications: Record<string, EmailNotificationOption>
}

export interface NotificationSettingResponse {
  notification_setting: NotificationSetting
}

export interface NotificationSettingUpdatePayload {
  notification_setting: {
    batched_notification_window?: BatchedNotificationWindow
    daily_digest_enabled?: boolean
    daily_digest_hour?: DailyDigestHour
    timezone?: string | null
    meeting_prep_enabled?: boolean
    meeting_prep_lead_days?: MeetingPrepLeadDays
    email_notifications?: Record<string, boolean>
  }
}
